import UltMeta, { Meta } from "./UltMeta/index";
import { THEME_COLOR } from "./common";

class PaymentState extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    REJECTED = new Meta(3, "已驳回");
    FINISHED = new Meta(2, "已完成", "color-info");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}
export const PAYMENT_STATE = new PaymentState();

class PaymentCollectionState extends UltMeta {
    CONFIRMING = new Meta(1, "待确认", THEME_COLOR.Primary.code);
    FINISHED = new Meta(2, "已完成", THEME_COLOR.Info.code);
    INVALIDING = new Meta(4, "作废中", THEME_COLOR.Primary.code);
    INVALID = new Meta(5, "已作废", THEME_COLOR.Info.code);
}

export const PAYMENT_COLLECTION_STATE = new PaymentCollectionState();

class PaymentType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "下游采购商-供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "下游采购商-联合购销商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合购销商-供应商");
}

export const PAYMENT_TYPE = new PaymentType();

class PaymentQueryType extends UltMeta {
    PAY_CUSTOMER = new Meta(1, "付款方");
    COLLECT_CUSTOMER = new Meta(2, "收款方");
}

export const PAYMENT_QUERY_TYPE = new PaymentQueryType();
